import InteractivePrototype from './interactivePrototype.ts';
import utils from '../utils.ts';
import CheckMark from './checkMark.ts';
import ListSorter from './tableListSorter.ts';
import { toHTML } from '../uTheory.Font/font.ts';

class ParallelKeysSort extends InteractivePrototype {
  constructor(displayDiv, options) {
    super();
    this.settings = {
      instructions: true,
      letters: {
        checkButton: true,
        letterButtons: false,
      },
      progressTracker: true,
      checkMark: {},
    };

    this.layout = {
      letters: { percent: 10 },
    };
    this.init(displayDiv, options);
  }

  init(displayDiv, options) {
    if (typeof options !== 'undefined') {
      this.compound = options.compound === true;
    }

    // now call the prototype's init function:
    super.init(displayDiv, options, this.settings).then(() => {
      this.progressTracker.start();
      this.letterPanel.addCheckCallback(this.checkAnswer, this);
      this.attempts = 0;
    });
  }

  displayInstructions() {
    this.instructionsDiv.innerHTML = 'Match the number of accidentals to the name of the key.';
  }

  createCustomDivs() {
    this.createDiv('listDiv', { width: '100%', height: 'auto' });
    this.displayDiv.removeChild(this.listDiv);
    this.displayDiv.insertBefore(this.listDiv, this.lettersDiv);
    this.checkMark = new CheckMark(this.listDiv);
  }

  initializeCustomElements() {
    function makeSpan(string) {
      return string
        .split('')
        .map((c) => {
          if (c === '#') return toHTML('accidental', '#');
          if (c === 'b') return toHTML('accidental', 'b');
          return c;
        })
        .join('');
    }

    const shuffler = [];
    for (let i = 1; i < 13; i++) {
      // 13 = 12 w/ parallels + headers
      shuffler.push(i);
    }
    utils.shuffle(shuffler);
    const shuffle = function (arr) {
      arr = arr.slice(0); // shallow copy;
      const shuffledArray = [arr[0]];
      for (let i = 0; i < shuffler.length; i++) {
        shuffledArray.push(arr[shuffler[i]]);
      }
      return shuffledArray;
    };

    const keys = shuffle(
      ['Key Name', 'C', 'G', 'D', 'A', 'E', 'B', 'F#', 'C#', 'F', 'Bb', 'Eb', 'Ab'].map(makeSpan)
    );

    const numberOfAccidentals = shuffle(
      ['Major key:', '0', '1#', '2#', '3#', '4#', '5#', '6#', '7#', '1b', '2b', '3b', '4b'].map(
        makeSpan
      )
    );

    const numberOfAccidentalsInMinor = shuffle(
      [
        'minor key:',
        '3b',
        '2b',
        '1b',
        '0',
        '1#',
        '2#',
        '3#',
        '4#',
        '4b',
        '5b',
        '6b',
        '7b',
        // "5#s", "6#s", "7#s", "0bs",
      ].map(makeSpan)
    );

    const lists = [keys, numberOfAccidentals, numberOfAccidentalsInMinor];

    this.listSorter = new ListSorter(this.listDiv, lists, {stripes: 'vertical'});
    this.layout.sortDiv = {
      div: this.listDiv,
      visible: true,
      percent: 85,
      callback: this.listSorter.resize.bind(this.listSorter),
    };
  }

  gameOver() {
    this.lettersDiv.style.display = 'none';
    this.listSorter.gameOver();
    super.gameOver();
  }

  exit() {
    this.listSorter?.gameOver();
    super.exit();
  }

  checkAnswer(rightBoolean) {
    this.attempts++;
    let answers = this.listSorter.check();
    if (typeof rightBoolean !== 'undefined') {
      answers = rightBoolean ? { right: 10, wrong: 0 } : { wrong: 10, right: 0 };
    }
    const gameOver = answers.wrong === 0;
    this.progressTracker.multipleAnswers(
      [
        {
          skill: 9,
          right: answers.right,
          wrong: answers.wrong,
          questions: answers.right + answers.wrong,
        },
      ],
      answers.right + answers.wrong,
      gameOver
    );
    if (gameOver) {
      this.checkMark.check(2);
      this.gameOver();
    } else {
      this.checkMark.x();
      if (this.attempts > 1) this.listSorter.hint();
    }
  }

  debugRightAnswer() {
    this.checkAnswer(true);
  }

  debugWrongAnswer() {
    this.checkAnswer(false);
  }
}

export default ParallelKeysSort;
